export const NEW_PACIENTE = "NEW_PACIENTE";
export const SET_PACIENTE = "SET_PACIENTE";
export const ADD_PATOLOGIA = "ADD_PATOLOGIA";
export const REMOVE_PATOLOGIA = "REMOVE_PATOLOGIA";
export const UPDATE_PATOLOGIA = "UPDATE_PATOLOGIA";
